import * as React from 'react';
import { useQuery } from 'react-query';
import { useFetchReportTemperatureControl } from 'hooks/api/temperature-control';
import { useTemperatureControlSearchParams } from 'hooks/store/temperature-control/use-temperature-control-search-params';
import XLSX from 'sheetjs-style-v2';
import * as FileSaver from 'file-saver';
import type { TTraceabilityEvent } from 'contracts/TraceabilityEvent';
import { Formatter } from 'utils';
export const TemperatureControleReport: React.FC = () => {
  const { fetchReportTemperatureControl } = useFetchReportTemperatureControl();
  const { filters } = useTemperatureControlSearchParams({ persisted: true });

  const temperatureControlReportQuery = useQuery({
    queryKey: ['fetch-report-temperature-control', filters],
    queryFn: () => {
      return fetchReportTemperatureControl({
        filters,
      });
    },
    enabled: false,
  });
  const isExportLoading = temperatureControlReportQuery.isFetching;

  const downloadFile = React.useCallback(
    (dataExport: any[], archiveName: string) => {
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet: charset=UTF8';
      const fileExtension = '.xlsx';

      const ws = XLSX.utils.json_to_sheet(dataExport);
      const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, archiveName + fileExtension);
    },
    []
  );

  const downloadReport = React.useCallback(() => {
    const reportData: TTraceabilityEvent[] =
      temperatureControlReportQuery.data?.data ?? [];

    if (reportData.length === 0) {
      return;
    }

    const payload = reportData.map((item) => {
      const latestTemperature = item.temperatures?.[0]?.temperature;

      return {
        Data: Formatter.date(item.eventDate, { format: 'dd/MM/yyyy - HH:mm' }),
        Produto: item.productDescription || 'N/A',
        Quantidade:
          [item.quantity, item.unit].filter(Boolean).join(' ') || 'N/A',
        Lote: item.productBatch || 'N/A',
        Filial: item.company?.tradeName || 'N/A',
        'Cód. Equipamento': item.equipment?.equipmentCode || 'N/A',
        Temperatura:
          typeof latestTemperature === 'number'
            ? `${latestTemperature} °C`
            : 'N/A',
      };
    });

    const archiveName = `RELATORIO-CONTROLE-TEMPERATURA-${new Date().toLocaleDateString()}`;
    downloadFile(payload, archiveName);
    temperatureControlReportQuery.remove();
  }, [downloadFile, temperatureControlReportQuery]);

  React.useEffect(() => {
    if (temperatureControlReportQuery.data) {
      downloadReport();
    }
  }, [temperatureControlReportQuery.data, downloadReport]);

  return (
    <div className={'flex items-center gap-2 font-GilroySemibold'}>
      <button
        onClick={() => temperatureControlReportQuery.refetch()}
        disabled={isExportLoading}
        className={
          'flex h-[30px] items-center gap-2 rounded-full bg-[#0CC769] px-4 text-sm text-white disabled:cursor-not-allowed disabled:opacity-80'
        }
      >
        <span>Exportar Excel</span>
        {isExportLoading ? (
          <div
            className={
              'h-4 w-4 animate-spin rounded-full border-2 border-white border-t-[#0CC769]'
            }
          />
        ) : null}
      </button>
    </div>
  );
};
